<template>
    <section id="main-content">
        <div class="row">
                    <div class="main-content-vfg">
                        <vue-form-generator 
                            :ref="'vfg'"
                            @on-complete="onComplete"
                            :schema="formSchema.pages[0].schema" 
                            :model="formSchema.model" 
                            :options="formSchema.options">
                        </vue-form-generator>
                    </div>
        </div>
    </section>
</template>
<script>
      
    // import VueFormGenerator from "vue-form-generator";
    Vue.use(VueFormGenerator); 
    
    export default {
        name: "WidgetForm",
        methods: {
         submit: function(model) {
         },
         onComplete: function() {
             this.$parent.onComplete()
         },           
         validate: function() {
                 return this.$refs['vfg'].validate()
            }
        },

        // components: {},

        // beforeCreate() {}, 

        // created() {}, 

        beforeMount() {},  

        mounted() {},    

        beforeDestroy() {},  

        destroyed() {},
        
        props: ['formSchema'],
            data: function() {
                return {
                    showPanelHeader: true,

                    // // model: this.$parent.formSchema.model,
                    // model: this.formSchema.model,

                    // schema: this.$parent.formSchema.pages[0].schema,

                    // options: this.$parent.formSchema.options

                }
            }

    }

</script>

<style>
    
</style>
